var React = require('react');

function IconPodcast (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","fillRule":"evenodd","d":"M12,3 C7.03,3 3,6.81789474 3,11.5263158 L3,18.1578947 C3,19.7305263 4.34,21 6,21 L9,21 L9,13.4210526 L5,13.4210526 L5,11.5263158 C5,7.86 8.13,4.89473684 12,4.89473684 C15.87,4.89473684 19,7.86 19,11.5263158 L19,13.4210526 L15,13.4210526 L15,21 L18,21 C19.66,21 21,19.7305263 21,18.1578947 L21,11.5263158 C21,6.81789474 16.97,3 12,3 L12,3 Z"}));
}

IconPodcast.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconPodcast;

IconPodcast.default = IconPodcast;
